<template>
  <div>
    <b-modal ref="modal" title="Novo Contas a Receber" header-class="border-bottom-0" size="lg" no-close-on-backdrop>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <search-input
              :alias="form.person_id.alias"
              v-model="form.person_id.value"
              :displayedValue="form.name.value"
              :form="form"
              :name="'person_id'"
              @search="searchPerson($event)"
              :searchResult="searchPersonResults.results"
              :isLoading="searchPersonResults.isLoading"
              @selected="setPerson($event)"
            >
              <search-input-option
                v-for="(row, index) in searchPersonResults.results.data"
                :key="index"
                :index="index"
                @click="setPerson(row)"
              >
                <div>
                  {{ row.name }}
                  <br />
                  <small class="text-muted">{{ row.cpf }}</small>
                  <br />
                </div>
              </search-input-option>
            </search-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <text-input
            :form="form"
            :name="'document'"
            v-model="form.document.value"
            :alias="form.document.alias" />
          </div>

          <div class="col-6">
            <select-input
              :form="form"
              :name="'payment_method'"
              v-model="form.payment_method.value"
              :options="form.payment_method.options"
              :alias="form.payment_method.alias"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Historico:</label>
              <textarea
                v-model="form.history.value"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
              ></textarea>
            </div>
          </div>
        </div>

        <br />

        <bill-parcel v-model="parcels"/>
        <button class="btn btn-link text-info" @click="openCalcParcel()" ><i class="fas fa-calculator" /> Gerador de Parcelas</button>
      </div>
      <br />

      <error-handler :error="error" />
      <calc-parcel ref="calcParcel" @parcels="setParcels($event)"/>

      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
      >{{ alertData.message }}</b-alert>

      <!-- form  -->

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Salvar
        </button>
        <!-- <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Salvar e adicionar outro
        </button> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "../../../mixins/Form";
import BillParcel from "../../sections/BillParcel.vue";
import moment from "moment";
import CalcParcel from "../../sections/CalcParcel.vue";

export default {
  components: {
    BillParcel,
    CalcParcel
  },

  data: function() {
    return {
      form: new Form({
        person_id: {
          alias: "Cliente",
          validate: {
            required: true
          }
        },

        name: {},

        document: {
          alias: "Documento",
          validate: {
            required: true
          }
        },

        history: {},

        payment_method: {
          alias: "Meio de Pagamento",
          options: {
            5: "Crédito Loja",
            15: "Boleto Bancário "
          },
          validate: {
            required: true
          }
        }
      }),

      parcels: {},

      selectedPerson: null,

      searchPersonResults: {
        results: {},
        isLoading: false
      },

      error: null,

      alertData: {
        isVisible: false,
        message: null
      }
    };
  },

  mounted() {
    // axios
    //   .post("api/accountplan/select")
    //   .then(response => {
    //     this.transactions = this.getGroupOptions(response.data);
    //     this.$store.commit("pageHasLoaded");
    //   })
    //   .catch(error => {
    //     this.error = error;
    //     this.$store.commit("pageHasLoadedWithError", { error: error });
    //   });
  },

  methods: {
    open(id) {
      //this.form.account_id.value = id;
      this.resetForm();

      this.$refs.modal.show();


    },

    openCalcParcel(){
        this.$refs.calcParcel.open()
    },

    setParcels(parcels) {
      this.parcels = parcels
    },

    getGroupOptions(data) {
      var options = {};

      for (let index in data) {
        options[data[index].id] = data[index].description;
      }

      return options;
    },

    searchPerson(search) {
      this.searchPersonResults.isLoading = true;

      axios
        .post(process.env.BASE_URL + "api/searchpersonbillreceiveble/select?page=" + search.page, {
          name: search.text,
          type: 'c',
          status: 1
        })
        .then(response => {
          this.searchPersonResults.results = response.data;

          this.searchPersonResults.isLoading = false;
        })
        .catch(error => {

          this.error = error;
        });
    },

    setPerson(person) {
      this.selectedPerson = person;

      this.form.person_id.value = person.id;

      this.form.name.value = person.name;
    },

    getAttributes() {
      return { ...this.form.getValues(), ...{ parcels: this.parcels } };
    },

    store() {

      if (this.form.isValid()) {
        this.$store.commit("showLoading");
        axios
          .post('api/billreceiveble/store', this.getAttributes())
          .then(response => {
            this.$refs.modal.hide();

            this.$store.commit("hideLoading");

            this.$emit("stored");

            this.$store.commit("showAlert", {
              message: "Lançamento efetuado!",
              type: "success"
            });

            return;
          })
          .catch(error => {
            this.error = error;

            this.$store.commit("hideLoading");

            return;
          });
      } else {

        this.form.isValid();

        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();

    }
  }
};
</script>
